<template>
  <section class="episodes-block">
    <div class="episodes-block__inner">
      <AppHeadingTitleSubtitle :title="props.data.title" :subtitle="props.data.subtitle" :styling="props.data.styling"/>
    </div>
    <swiper
        slides-per-view="auto"
        class="episodes-block__slider swiper-fade-in"
        :watch-overflow="true"
        @swiper="useSwiper"
    >
      <swiper-slide
          v-for="(episodeRef, index) in data.episodes"
          :key="`episode_${index}`"
          class="episodes-block__slider-slide"
      >
        <AppEpisodeItem
            :data="episodeRef"
        />
      </swiper-slide>

      <AppSwiperControls>
        <AppButton :url="data.cta_url" :title="data.cta_label" :end-icon="true"/>
      </AppSwiperControls>

    </swiper>
  </section>
</template>

<script setup lang="ts">
import {Swiper, SwiperSlide} from 'swiper/vue'
import 'swiper/css'
import {TEpisodesBlock} from '~/types/block-types'
import {useSwiper} from "~/composables/useSwiper";

const props = defineProps<{
  data: TEpisodesBlock,
}>()

</script>

<style scoped lang="postcss">
.episodes-block {
  width: 100%;
  overflow: clip;
  color: var(--color-blue-aqua);
  @mixin app-block-margins;

  &__inner {
    @mixin container;
    @mixin app-container-padding;
    @mixin app-content-block-title-margins;
  }

  &__slider {
    @mixin app-block-margins;
    margin-left: -1rem;
    margin-right: -1rem;
  }

  &__slider-slide {
    margin-right: 0.75rem;
    width: fit-content;

    &:last-child {
      margin-right: 0px;
    }
  }
}
</style>
